import { FC, useState } from "react";

import { CenterContent } from "shared/styles";
import { ContentWidth } from "shared/styles/constants";
import { Card } from "shared/components";
import { copy } from "shared/assets";
import { Band, Wallet } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import {
  InvoicesTable,
  SubscriptionRequestsTable,
  SubscriptionsTable,
} from "Bands/pages/company-dashboard/containers";
import { CancelSubscriptionModal } from "Bands/containers";

const dashboardCopy = copy.companyDashboard;

export const CompanyDashboard: FC = () => {
  const [showCancelSubscriptionModal, setShowCancelSubscriptionModal] = useState<string | null>(
    null
  ); // subscriptionId

  return (
    <CenterContent width={ContentWidth.wide}>
      <Spacer size="l">
        <SubscriptionRequestsTable />
        <Card icon={Band} title={dashboardCopy.subscriptions.title}>
          <SubscriptionsTable setShowCancelSubscriptionModal={setShowCancelSubscriptionModal} />
        </Card>
        <Card icon={Wallet} title={dashboardCopy.invoices.title}>
          <InvoicesTable />
        </Card>
      </Spacer>
      {showCancelSubscriptionModal && (
        <CancelSubscriptionModal
          refetchBand
          refetchCompany
          subscriptionId={showCancelSubscriptionModal}
          handleClose={() => setShowCancelSubscriptionModal(null)}
        />
      )}
    </CenterContent>
  );
};
